import { render, staticRenderFns } from "./PopupShowProduct.vue?vue&type=template&id=6f76340c"
import script from "./PopupShowProduct.vue?vue&type=script&lang=js"
export * from "./PopupShowProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports